module.exports = __webpack_public_path__ + "img/icon-nav-bottom-logo.77dffb92.png";